
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs",
      function () {
        return require("private-next-pages/blogs/index.ts");
      }
    ]);
  